import {useEffect} from 'react';
import {createFileRoute, redirect, useNavigate} from '@tanstack/react-router';

import {useAuthStore} from '@/store/auth';
import {useAuth} from '@/hooks/useAuth';
import {ForgotPasswordPage} from '@/modules/auth/pages/ForgotPasswordPage';

export const Route = createFileRoute('/forgot-password')({
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated) {
      throw redirect({to: '/'});
    }
  },
  component: ForgotPasswordGuard,
});

function ForgotPasswordGuard() {
  const {isAuthenticated, isLoading} = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      // replace: true — /forgot-password is not a place an authenticated
      // user should be able to back-button to. Matches login.tsx.
      void navigate({to: '/', replace: true});
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (!isLoading && isAuthenticated) {
    return null;
  }

  return <ForgotPasswordPage />;
}
